import Head from 'next/head'
import React from 'react'
import { SEOTitleProps } from './types'

const SEOTitle: React.FC<SEOTitleProps> = ({ title, enable = true }) =>
  enable ? (
    <Head>
      <title key="title">{title}</title>
    </Head>
  ) : null

export default SEOTitle
